var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "exercise-record" }, [
    _c("div", { staticClass: "record-header" }, [
      _c("div", { staticClass: "title-wrapper" }, [
        _c("div", { staticClass: "title-bar" }),
        _c("h3", { staticClass: "title" }, [_vm._v("运动记录")]),
        _c("span", { staticClass: "total-time" }, [
          _vm._v("总时长：" + _vm._s(_vm.totalTime) + "分钟"),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "time-tabs" },
        _vm._l(_vm.tabs, function (tab) {
          return _c(
            "button",
            {
              key: tab.value,
              class: ["tab-btn", { active: _vm.activeTab === tab.value }],
              on: {
                click: function ($event) {
                  return _vm.handleTabChange(tab.value)
                },
              },
            },
            [_vm._v(" " + _vm._s(tab.label) + " ")]
          )
        }),
        0
      ),
    ]),
    _c("div", { staticClass: "record-content" }, [
      _c("div", { staticClass: "left-stats" }, [
        _vm._m(0),
        _vm._m(1),
        _c("div", { staticClass: "stat-row" }, [
          _c("div", { staticClass: "stat-item" }, [
            _c("span", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.stats.standard || 0)),
            ]),
            _c("span", { staticClass: "stat-unit" }, [_vm._v("天")]),
          ]),
          _c("div", { staticClass: "stat-item" }, [
            _c("span", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.stats.notStandard || 0)),
            ]),
            _c("span", { staticClass: "stat-unit" }, [_vm._v("天")]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "exercise-list" },
        [
          _vm._l(_vm.displayList, function (exercise, index) {
            return _c("div", { key: index, staticClass: "exercise-item" }, [
              _c("div", { staticClass: "exercise-image" }, [
                exercise.image
                  ? _c("img", {
                      attrs: { src: exercise.image, alt: exercise.name },
                    })
                  : _c("img", {
                      attrs: {
                        src: require("@/assets/icon/zanwu.png"),
                        alt: "",
                      },
                    }),
                exercise.isStandard !== undefined
                  ? _c(
                      "div",
                      {
                        staticClass: "status-badge",
                        class: exercise.isStandard
                          ? "standard"
                          : "not-standard",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(exercise.isStandard ? "达标" : "未达标") +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "exercise-time" }, [
                _c("span", { staticClass: "time" }, [
                  _vm._v(_vm._s(exercise.time)),
                ]),
                _c("span", { staticClass: "time-unit" }, [_vm._v("分钟")]),
              ]),
              _c("div", { staticClass: "exercise-name" }, [
                _vm._v(_vm._s(exercise.name)),
              ]),
            ])
          }),
          _vm.displayList.length === 0
            ? _c("div", { staticClass: "empty-text" }, [_vm._v(" 暂无记录 ")])
            : _vm._e(),
        ],
        2
      ),
    ]),
    _c("div", { staticClass: "progress-bar" }, [
      _c("div", {
        staticClass: "progress-fill",
        style: { width: _vm.progressPercent + "%" },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "exercise-icon" }, [
      _c("div", { staticClass: "icon-circle" }, [
        _c("img", {
          staticStyle: { width: "60px" },
          attrs: { src: require("@/assets/icon/yundong.png"), alt: "" },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "legend" }, [
      _c("div", { staticClass: "legend-item" }, [
        _c("span", { staticClass: "legend-dot blue" }),
        _c("span", { staticClass: "legend-label" }, [_vm._v("达标天数")]),
      ]),
      _c("div", { staticClass: "legend-item" }, [
        _c("span", { staticClass: "legend-dot orange" }),
        _c("span", { staticClass: "legend-label" }, [_vm._v("未达标天数")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }